import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';

import ProductClass from '../../../types/ProductClass';
import ProductPriceRange from '../ProductPriceRange';
import ProductPrice from '../ProductPrice';
import { modelOf } from '../../../prop-types';
import Product from '../../../models/Product';
import AccountStore from '../../../store/AccountStore';
import ConfigStore from '../../../store/ConfigStore';

@observer
export class PriceWrapper extends Component {
  showPrices = (configStore, accountStore) => {
    const hideTaxIncludedInfo = configStore.product.showSecondaryTaxPrice;
    const retailer = accountStore.isRetailer;
    return { hideTaxIncludedInfo, retailer };
  };

  render() {
    const {
      product,
      withTax,
      accountStore,
      configStore,
      isSecondaryPrice,
      isMultiProductPicker,
      depositInPrice
    } = this.props;
    const { hideTaxIncludedInfo, retailer } = this.showPrices(
      configStore,
      accountStore
    );
    const showTaxIncludedInfo = withTax && (hideTaxIncludedInfo || retailer);

    let price = null;
    if (product.class === ProductClass.MULTI) {
      const priceRange = withTax
        ? product.multi.getSecondaryPriceRange(withTax)
        : product.multi.priceRange;
      if (priceRange && priceRange.min && priceRange.max) {
        price =
          priceRange.min !== priceRange.max ? (
            <ProductPriceRange
              range={priceRange}
              withTax={withTax}
              showTaxIncludedInfo={showTaxIncludedInfo}
              isSecondaryPrice={isSecondaryPrice}
            />
          ) : (
            <ProductPrice
              product={product}
              priceInfo={priceRange.min}
              withTax={withTax}
              showTaxIncludedInfo={showTaxIncludedInfo}
              isSecondaryPrice={isSecondaryPrice}
              depositInPrice={depositInPrice}
            />
          );
      }
    } else {
      if (product.price_info) {
        price = (
          <ProductPrice
            product={product}
            priceInfo={product.price_info}
            withTax={withTax}
            showTaxIncludedInfo={showTaxIncludedInfo}
            isSecondaryPrice={isSecondaryPrice}
            isMultiProductPicker={isMultiProductPicker}
            depositInPrice={depositInPrice}
          />
        );
      }
    }
    return price;
  }
}

PriceWrapper.propTypes = {
  product: PropTypes.oneOfType([modelOf(Product), PropTypes.object]).isRequired,
  withTax: PropTypes.bool.isRequired,
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  isSecondaryPrice: PropTypes.bool,
  isMultiProductPicker: PropTypes.bool,
  depositInPrice: PropTypes.bool
};

PriceWrapper.defaultProps = {
  depositInPrice: false
};

export default inject((stores, props) => ({
  accountStore: stores.accountStore,
  configStore: stores.configStore,
  withTax: isNil(props.withTax)
    ? stores.accountStore.showPricesWithTax
    : props.withTax
}))(PriceWrapper);



// WEBPACK FOOTER //
// ./src/components/product/PriceWrapper/index.jsx